import UpdatePaymentForm from './UpdatePaymentForm';

export default UpdatePaymentForm;
